import React from "react";
import {connect} from "react-redux";

import Forma from "./Form";
import {loadForm} from "../../redux/formReducer";
import Error from "../Events/Error/Error";

type Props = {
    loadForm: (data: object, id: string) => Promise<any>;
    subjectPurchase: string;
    purchaseId: string;
    error: boolean;
    personalNumberPurchase: string
}

const FormContainer: React.FC<Props> = ({loadForm, subjectPurchase, purchaseId, error, personalNumberPurchase}: Props) => {
    if (error) {
        return <Error/>
    } else return <Forma purchaseId={purchaseId} personalNumberPurchase={personalNumberPurchase} subjectPurchase={subjectPurchase} loadFormData={loadForm}/>
};

const mapStateToProps = (state: any) => {
    return {
        purchaseId: state.form.data.purchaseId,
        subjectPurchase: state.form.data.subjectPurchase,
        error: state.form.error,
        personalNumberPurchase:  state.form.data.personalNumberPurchase
    }
};

// @ts-ignore
export default connect(mapStateToProps, {loadForm})(FormContainer);
